export default function ChatInput({
                                     value,
                                     onChange,
                                     onSend,
                                     disabled,
                                     inputRowStyle,
                                     inputStyle,
                                     buttonStyle,
                                 }) {
    const MAX_LENGTH = 500;

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) onSend();
    };

    const handleChange = (e) => {
        onChange(e.target.value);
    };

    return (
        <div style={inputRowStyle}>
            <input
                style={inputStyle}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Запитайте щось"
                disabled={disabled}
                maxLength={MAX_LENGTH}
            />
            <button style={buttonStyle} onClick={onSend} disabled={disabled}>
                ➤
            </button>
        </div>
    );
}
